import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useState } from 'react';
import LearnMoreModal from './learn-more-modal';
import { config } from '@/config/environment';

const MainDiv = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  justify-content: space-between;
  padding: 0 20px;
`;
const Reason = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;
`;
const IconDiv = styled.div`
  width: 72px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const Icon = styled.img`
  width: 72px;
  height: auto;
`;
const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 32px;
  width: 70%;
`;
const Heading = styled(Typography)`
  font-family: var(--font-work-sans);
  font-weight: 600;
  font-size: 20px;
  line-height: 136.8%;
  color: #231727;
  margin-top: 5px;
`;
const Title = styled(Typography)`
  font-family: var(--font-work-sans);
  font-weight: 500;
  font-size: 28px;
  line-height: 127.3%;
  color: #231727;
`;
const Link = styled(Typography)`
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 159.3%;
  color: #4d66b1;
`;
const MobileView = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [reason, setReason] = useState<string>('');
  return (
    <MainDiv>
      <Title>
        {config.platformMode === 'archive' ? 'Community members became Hosts to...' : 'Why host?'}
      </Title>
      <Reason>
        <IconDiv>
          <Icon src={'/discover/hosting/mobile/reason1.png'} alt={'Icon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Share what you love</Heading>
          <Link
            onClick={() => {
              setOpen(true);
              setReason('reason1');
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Reason>
      <Reason>
        <IconDiv>
          <Icon src={'/discover/hosting/mobile/reason2.png'} alt={'icon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Set your own schedule</Heading>
          <Link
            onClick={() => {
              setOpen(true);
              setReason('reason2');
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Reason>
      <Reason>
        <IconDiv>
          <Icon src={'/discover/hosting/mobile/reason3.png'} alt={'icon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Gain Perspective</Heading>
          <Link
            onClick={() => {
              setOpen(true);
              setReason('reason3');
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Reason>
      <Reason>
        <IconDiv>
          <Icon src={'/discover/hosting/mobile/reason4.png'} alt={'videoIcon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Learn and grow</Heading>
          <Link
            onClick={() => {
              setOpen(true);
              setReason('reason4');
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Reason>
      <Reason>
        <IconDiv>
          <Icon src={'/discover/hosting/mobile/reason5.png'} alt={'icon'} />
        </IconDiv>
        <TextDiv>
          <Heading>Be part of the change you want to see</Heading>
          <Link
            onClick={() => {
              setOpen(true);
              setReason('reason5');
            }}
          >
            Learn more
          </Link>
        </TextDiv>
      </Reason>
      <LearnMoreModal open={open} onClose={() => setOpen(false)} reason={reason} />
    </MainDiv>
  );
};

export default MobileView;
